export const CALENDAR_DISPLAY = 'CALENDAR_DISPLAY';
export const SUMMER_PACK = 'SUMMER_PACK';
export const NNLIVE = 'NNLIVE';
export const CYBER_MONDAY = 'CYBER_MONDAY';
export const MARCH_MADNESS_DISPLAY = 'MARCH_MADNESS_2025_DISPLAY';
export const CALENDAR_DISPLAY_2025 = 'CALENDAR_DISPLAY_2025';
export const NNLXMAS2025_DISPLAY = 'NNLXMAS2025_DISPLAY';

